// extracted by mini-css-extract-plugin
export default {"footer":"N_s","row":"N_dG","menu-column":"N_dH"};